import { reactive } from "vue";
import { desiredMediaState } from "./media/state";
import { addNotification, removeNotification } from "./notifications";
import { locale } from "../locale";
import { mediaActions } from "./media/actions";
import { isActiveRoom } from "./useActiveRoomState";

const state = reactive({
  activeNotification: null as string | null,
  locked: false,
});

export function setSpeak(val: boolean) {
  if (val && !state.locked && !desiredMediaState.microEnabled && !state.activeNotification && isActiveRoom.value) {
    state.locked = true;
    state.activeNotification = addNotification(
      10,
      locale.speakOnMicroOff,
      undefined,
      true,
      {
        text: locale.on,
        style: "white-not-btn",
        action: () => {
          mediaActions.microOn()
        }
      },
      () => {
        state.activeNotification = null;
      }
    );
  }
}

export function speakMicroOn() {
  if (state.activeNotification) {
    removeNotification(state.activeNotification);
  }
  state.activeNotification = null;
  state.locked = false;
}

export function speakMicroOff() {}
